export default __webpack_public_path__ + "static/media/super_admin_restaurants_icon.f6c99285.svg";